import {
  getAsyncSelectShowSelectedApiParamIdPK,
  InputMultiSelectControl,
  MultiSelect,
  SelectDropdownListFooter,
  SelectDropdownListHeader,
} from '../../Select'
import { BuildingGroupSelect } from '../BuildingGroupSelect'

import { BUILDING_GROUP_MULTI_SELECT_DROPDOWN_FLOATING_CONFIG_SELECT_ALL } from './BuildingGroupMultiSelect.constants'

import BuildingIcon from '../../../icons/buildings-group.svg'

function BuildingGroupMultiSelect({
  Control = InputMultiSelectControl,
  dropdownFloatingConfig = BUILDING_GROUP_MULTI_SELECT_DROPDOWN_FLOATING_CONFIG_SELECT_ALL,
  getShowSelectedApiParam = getAsyncSelectShowSelectedApiParamIdPK,
  listProps,
  tagsProps,
  onClear,
  onSelectItem,
  ...restProps
}) {
  return (
    <MultiSelect
      {...restProps}
      Control={Control}
      EntityIcon={BuildingIcon}
      Select={BuildingGroupSelect}
      dropdownFloatingConfig={dropdownFloatingConfig}
      getShowSelectedApiParam={getShowSelectedApiParam}
      listProps={{
        ...listProps,
        Footer: listProps?.SelectDropdownListFooter || SelectDropdownListFooter,
        Header: listProps?.SelectDropdownListHeader || SelectDropdownListHeader,
      }}
      tagsProps={{
        ...tagsProps,
        onChange: onSelectItem,
        onClear,
      }}
      onClear={onClear}
      onSelectItem={onSelectItem}
    />
  )
}

export default BuildingGroupMultiSelect
